import axios from 'axios'
import { API_BASE } from '../constants/api'
import { API } from '../constants/types'
import { fetchFailed, fetchRequested, fetchSucceeded } from '../actions/api'

const apiMiddleware = store => next => action => {

    if (next) next(action);

    const { type, payload } = action;

    const token1 = localStorage.getItem("authToken")
    const token = token1?.replace(/['"]+/g, '')
    // console.log(token.replace(/['"]+/g, ''));
    // console.log("🚀 ~ file: api.js ~ line 13 ~ apiMiddleware ~ token", token?.data?.accessToken)


    if (type === API) {
        const {
            url,
            data,
            request = fetchRequested,
            success = fetchSucceeded,
            error = fetchFailed,
            method = 'get'
        } = payload;

        store.dispatch(request({ payload }));

        return axios({
            baseURL: API_BASE, method, url, data, headers: { "Authorization": `${token}` }
        }).then(res => {
            store.dispatch(success(res.data));
            return Promise.resolve(res.data);
        }).catch(err => {
            store.dispatch(error(err.response.data));

            return Promise.reject(err.response.data);
        });
    }
}

export default apiMiddleware;